// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JSAE6PNg_XQkdS76eFTz{background:var(--background-primary-inverted-primary);color:var(--content-primary-primary);border-radius:6px;align-items:center;gap:8px;padding:8px 4px;font-size:13px;font-style:normal;font-weight:400;line-height:16px;display:flex;box-shadow:0 4px 12px -2px rgba(18,19,23,.03)}.JSAE6PNg_XQkdS76eFTz p{margin:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `JSAE6PNg_XQkdS76eFTz`
};
export default ___CSS_LOADER_EXPORT___;
